const SERVICE_WORKER_UPDATE_PENDING_STORAGE_KEY = 'brp_dealer_portal_service_worker_update_pending';
export const SERVICE_WORKER_UPDATE_PENDING_CHANGED_EVENT = 'service-worker-update-pending-changed';

const canUseSessionStorage = () => typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

const createPendingChangedEvent = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (typeof window.CustomEvent === 'function') {
    return new window.CustomEvent(SERVICE_WORKER_UPDATE_PENDING_CHANGED_EVENT);
  }

  if (typeof window.Event === 'function') {
    return new window.Event(SERVICE_WORKER_UPDATE_PENDING_CHANGED_EVENT);
  }

  const event = document.createEvent('Event');
  event.initEvent(SERVICE_WORKER_UPDATE_PENDING_CHANGED_EVENT, false, false);
  return event;
};

const readStoredPendingState = () => {
  if (!canUseSessionStorage()) {
    return false;
  }

  try {
    return window.sessionStorage.getItem(SERVICE_WORKER_UPDATE_PENDING_STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
};

let isServiceWorkerUpdatePending = readStoredPendingState();

const persistPendingState = nextValue => {
  if (!canUseSessionStorage()) {
    return;
  }

  try {
    if (nextValue) {
      window.sessionStorage.setItem(SERVICE_WORKER_UPDATE_PENDING_STORAGE_KEY, '1');
    } else {
      window.sessionStorage.removeItem(SERVICE_WORKER_UPDATE_PENDING_STORAGE_KEY);
    }
  } catch (error) {
    return;
  }
};

const notifyPendingStateChanged = () => {
  const event = createPendingChangedEvent();

  if (event) {
    window.dispatchEvent(event);
  }
};

export const getIsServiceWorkerUpdatePending = () => isServiceWorkerUpdatePending;

export const setServiceWorkerUpdatePending = nextValue => {
  const normalizedValue = Boolean(nextValue);

  if (isServiceWorkerUpdatePending === normalizedValue) {
    return;
  }

  isServiceWorkerUpdatePending = normalizedValue;
  persistPendingState(normalizedValue);
  notifyPendingStateChanged();
};

export const clearServiceWorkerUpdatePending = () => {
  setServiceWorkerUpdatePending(false);
};
